import React from 'react';
import { useParams } from 'react-router';
import HelpPage from '../../Units/HelpPage';
import clubDataHelp from '../../../config/clubDataHelp';

const ClubDataHelp = () => {
    const { id: unionId } = useParams();
    return (
        <HelpPage
            backTo={`/union/${unionId}/data`}
            items={clubDataHelp}
        />
    );
}

export default ClubDataHelp;